module.exports = __webpack_public_path__ + "media/tulum/rock_iguana-e62f8e68.jpg";